webpackJsonp([103183360694013],{

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRouter = __webpack_require__(15);
	
	var _reactCustomScrollbars = __webpack_require__(58);
	
	var _reactHelmet = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TroubleshootingPage = function (_React$Component) {
	  _inherits(TroubleshootingPage, _React$Component);
	
	  function TroubleshootingPage() {
	    _classCallCheck(this, TroubleshootingPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TroubleshootingPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { id: 'community-rules', className: 'page community-rules' },
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Community Rules'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'ParkYou! unites micro-communities of city car owners to instantaneously find street parking. We are launching in Fall 2018. Read our community rules here.' })
	      ),
	      _react2.default.createElement(
	        _reactCustomScrollbars.Scrollbars,
	        { className: 'article' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Troubleshooting'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Coming soon!'
	        )
	      )
	    );
	  };
	
	  return TroubleshootingPage;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRouter.withRouter)(TroubleshootingPage);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-troubleshooting-js-19e0aec65109afdced14.js